namespace Solovis.InvDataSelectors {

    export class InvestmentSelectorControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public _currentInvestment;
        public selectionCallback;
        public cancelCallback;
        public _currentInvestmentInfo;

        public _tabStripControl: Solovis.UI.TabStripControl;
        public _tabToActivate;

        constructor(options) {
            super(options);

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this._currentInvestment = options.initialValue ? options.initialValue : null;

            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;

            this._currentInvestmentInfo = null;
        }

        public doInit() {
        }

        public focus() {
            this._tabStripControl.activateTab("byName");

            var tabModel = this._tabStripControl.getActiveTabModel();

            if (tabModel && tabModel.custom.investmentSelectorByNameControl) {
                tabModel.custom.investmentSelectorByNameControl.focus();
            }
        }

        public activateTab(tabModelOrCodeOrIndex) {
            var self = this;

            if (this.state === Solovis.UI.BaseControl.ControlState.afterRender) {
                this._tabStripControl.activateTab(tabModelOrCodeOrIndex);
            }
            else {
                // The control is still rendering, so we will store the tab to activate and defer until the render is complete
                this._tabToActivate = tabModelOrCodeOrIndex;
            }
        }

        public setAvailableHeight(overallHeight) {
            var self = this;

            var tabPickerHeight = this._tabStripControl.getTabPickerHeight();

            var tabContentHeight = overallHeight - tabPickerHeight;

            var byOwnerTab = this._tabStripControl.getTabModelByTabCode("byOwner");

            if (byOwnerTab.custom.byOwnerTabControl) {
                byOwnerTab.custom.byOwnerTabControl.setAvailableHeight(tabContentHeight);
            }
            else {
                // The tab has not been activated yet, so store the available height to be used when it renders
                byOwnerTab.custom._availableHeight = tabContentHeight;
            }

            var byHoldingTab = this._tabStripControl.getTabModelByTabCode("byHolding");

            if (byHoldingTab.custom.byHoldingTabControl) {
                byHoldingTab.custom.byHoldingTabControl.setAvailableHeight(tabContentHeight);
            }
            else {
                // The tab has not been activated yet, so store the available height to be used when it renders
                byHoldingTab.custom._availableHeight = tabContentHeight;
            }

        }

        public doRender() {
            var self = this;

            var tabStripControlHostDiv = $("<div>")
                .css("margin-top", "5px")
                .appendTo(this.container);

            var tabs = [];

            var byNameTab = {
                code: "byName",
                label: "By Name",
                init: function () {

                    var tabModel = this;

                    var investmentSelectorByNameControlHostDiv = $("<div>").appendTo(this.tabContentDiv);
                    var investmentSelectorByNameControlHost = new Solovis.UI.ControlHost({ container: investmentSelectorByNameControlHostDiv });
                    tabModel.custom.investmentSelectorByNameControl = new Solovis.InvDataSelectors.InvestmentSelectorControl.InvestmentSelectorByNameControl({
                        controlHost: investmentSelectorByNameControlHostDiv,
                        portalServices: self._portalServices,
                        selectionCallback: function (investment) {
                            self._currentInvestment = investment;
                            self.selectionCallback(investment);
                        },
                        cancelCallback: self.cancelCallback
                    });
                    investmentSelectorByNameControlHost.setCurrentControl(tabModel.custom.investmentSelectorByNameControl);
                },
                activate: function () {
                    $(self).trigger("currentViewInfoChanged");
                }
            };

            var byOwnerTab = {
                code: "byOwner",
                label: "By Owner",
                activate: function () {
                    var tabModel = this;

                    var byOwnerTabControlHostDiv = $("<div>")
                        .appendTo(tabModel.tabContentDiv);

                    if (!tabModel.custom.byOwnerTabControl) {
                        tabModel.custom.byOwnerTabControl = new Solovis.InvDataSelectors.InvestmentSelectorControl.ByOwnerOrHoldingTabControl({
                            controlHost: byOwnerTabControlHostDiv,
                            portalServices: self._portalServices,
                            type: "owner",
                            selectionCallback: self.selectionCallback,
                            currentInvestment: self._currentInvestment,
                            currentInvestmentInfo: self._currentInvestmentInfo
                        });

                        $(tabModel.custom.byOwnerTabControl).on("renderComplete", function () {
                            if (self._currentInvestment && !self._currentInvestmentInfo) {
                                self._currentInvestmentInfo = tabModel.custom.byOwnerTabControl.getCurrentInvestmentInfo();
                            }

                            if (tabModel.custom._availableHeight) {
                                tabModel.custom.byOwnerTabControl.setAvailableHeight(tabModel.custom._availableHeight);
                                tabModel.custom._availableHeight = null;
                            }

                            $(self).trigger("currentViewInfoChanged");

                        });

                        tabModel.custom.byOwnerTabControl.setAsCurrentControl();
                    }
                    else {
                        $(self).trigger("currentViewInfoChanged");
                    }
                }
            };

            var byHoldingTab = {
                code: "byHolding",
                label: "By Holding",
                activate: function () {
                    var tabModel = this;

                    var byHoldingTabControlHostDiv = $("<div>")
                        .appendTo(tabModel.tabContentDiv);

                    if (!tabModel.custom.byHoldingTabControl) {
                        tabModel.custom.byHoldingTabControl = new Solovis.InvDataSelectors.InvestmentSelectorControl.ByOwnerOrHoldingTabControl({
                            controlHost: byHoldingTabControlHostDiv,
                            portalServices: self._portalServices,
                            type: "holding",
                            selectionCallback: self.selectionCallback,
                            currentInvestment: self._currentInvestment,
                            currentInvestmentInfo: self._currentInvestmentInfo
                        });

                        $(tabModel.custom.byHoldingTabControl).on("renderComplete", function () {
                            if (self._currentInvestment && !self._currentInvestmentInfo) {
                                self._currentInvestmentInfo = tabModel.custom.byHoldingTabControl.getCurrentInvestmentInfo();
                            }

                            if (tabModel.custom._availableHeight) {
                                tabModel.custom.byHoldingTabControl.setAvailableHeight(tabModel.custom._availableHeight);
                                tabModel.custom._availableHeight = null;
                            }

                            $(self).trigger("currentViewInfoChanged");

                        });

                        tabModel.custom.byHoldingTabControl.setAsCurrentControl();
                    }
                    else {
                        $(self).trigger("currentViewInfoChanged");
                    }
                }

            };

            tabs.push(byNameTab, byOwnerTab, byHoldingTab);

            this._tabStripControl = new Solovis.UI.TabStripControl({
                controlHost: tabStripControlHostDiv,
                tabs: tabs
            });

            this._tabStripControl.setAsCurrentControl();

            if (this._tabToActivate) {
                this.activateTab(this._tabToActivate);
                this._tabToActivate = null;
            }
        };

        public getActiveTabModel() {
            return this._tabStripControl.getActiveTabModel();
        };

        public getCurrentViewInfo() {
            var viewInfo: any = {};

            var activeTabModel = this._tabStripControl.getActiveTabModel();

            viewInfo.activeTabCode = activeTabModel ? activeTabModel.tabCode : null;

            return viewInfo;
        }    
    }
    
}


namespace Solovis.InvDataSelectors.InvestmentSelectorControl {

    export class InvestmentSelectorByNameControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public selectionCallback;
        public cancelCallback;

        public searchBox: JQuery;


        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;

            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;
        }

        public doInit() {
        }

        public doRender() {
            var self = this;

            var itemsToDisplay = 10;
            var moreResultsToDisplay = 500;

            let findItems = (autocompleteRequest, responseCallback) => {

                var filterText = autocompleteRequest.term;

                this._portalServices.rpc().invoke("~/Selectors/InvestmentSelector/FindInvestment", { filterText: filterText, excludeDemotedItems: true, maxItems: itemsToDisplay },
                    function (response, success) {
                        if (success) {
                            var result = response.result;
                            var data = result.data;

                            if (result.hasMoreData || result.hasExcludedItems) {
                                data.splice(itemsToDisplay, 1, { showMoreResults: true, filterText: filterText });
                            }
                            responseCallback(data);
                        }
                        else {
                            // TODO: report error somehow
                            responseCallback([]);
                        }
                    });
            }

            this.searchBox = $("<input>")
                .attr("type", "text")
                .css("width", "100%")
                .appendTo(this.container);

            (this.searchBox as any).autocomplete({
                minLength: 1,
                source: findItems,
                focus: function (event, ui) {
                    if (ui.item)
                        self.searchBox.val(ui.item.label);
                    return false;
                },
                select: (event, ui) => {
                    if (ui.item) {
                        if (ui.item.showMoreResults) {
                            this._portalServices.rpc().invoke("~/Selectors/InvestmentSelector/FindInvestment", { filterText: ui.item.filterText, excludeDemotedItems: false, includeAll: true },
                                function (response, success) {
                                    if (success) {
                                        var data = response.result.data;

                                        Solovis.UI.Dialogs.StringFilterListDialog.showDialog({
                                            title: "Select Investment",
                                            selectCallback: function (selectedItem) {
                                                if (self.selectionCallback) {
                                                    self.selectionCallback(selectedItem);
                                                }
                                            },
                                            stringFilterListControlOptions: {
                                                listItems: data,
                                                itemDivGenerator: function (itemHolder, filterOptions) {
                                                    var itemDiv = $("<div>").text(itemHolder.item.label);
                                                    itemDiv.prepend(Solovis.UI.Icons.createInvestmentIcon({ "padding-right": "10px" }));
                                                    return itemDiv;
                                                }
                                            }
                                        });
                                    }
                                    else {
                                        // TODO: report error somehow
                                    }
                                });
                        }
                        else {
                            self.searchBox.val(ui.item.label);

                            if (self.selectionCallback) {
                                var item = {
                                    investmentId: ui.item.investmentId,
                                    label: ui.item.label,
                                    resourceId: ui.item.resourceId
                                };
                                self.selectionCallback(item);
                            }
                        }

                    }
                    return false;
                },
                search: function (event, ui) {
                    // NOTE: spinners are built into the control
                    this.waitImageDiv = Solovis.UI.StockAnimations.createSpinningCircles({
                        diameter: "20px",
                        top: $(this).position().top + 20,
                        left: $(this).width() + 15,
                    })
                        .insertAfter(this);
                },
                response: function (event, ui) {
                    if (this.waitImageDiv) {
                        this.waitImageDiv.remove();
                    }
                }
            })
                .data("ui-autocomplete")._renderItem = function (ul, item) {
                    var itemLink = $("<a>");
                    var itemElement = $("<li>");

                    if (item.showMoreResults) {
                        itemLink.append(Solovis.UI.Icons.createMoreResultsIcon({ "padding-right": "10px" }))
                            .append(
                            $("<strong>").text("Show More Results")
                            );
                    }

                    else {
                        var label = item.label;
                        itemLink.text(label);

                        Solovis.UI.Icons.createInvestmentIcon({ "padding-right": "10px" })
                            .prependTo(itemLink);
                    }

                    itemElement.append(itemLink);
                    itemElement.appendTo(ul);
                    return itemElement;
                };

            // Trigger cancel when escape is pressed.
            $(this.searchBox).keyup(function (e) {
                if (e.keyCode == 27) {
                    // Escape was pressed.
                    if (self.cancelCallback) {
                        self.cancelCallback();
                    }
                }
            });
        }

        public focus() {
            if (this.searchBox) {
                this.searchBox.focus();
            }
        }
    }


    export class ByOwnerOrHoldingTabControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public _type;
        public _selectionCallback;
        public _currentInvestment;
        public _currentInvestmentInfo;
        public _initErrorText;

        public _investmentsStringFilterListControl: Solovis.UI.StringFilterListControl;

        public _formDiv: JQuery;
        public _formBuilder: Solovis.UI.InputControls.FormBuilder;

        public _availableHeight;


        constructor(options) {
            super(options);

            this._portalServices = options.portalServices;

            this._type = options.type;
            this._selectionCallback = options.selectionCallback;
            this._currentInvestment = options.currentInvestment ? options.currentInvestment : null;
            this._currentInvestmentInfo = options.currentInvestmentInfo ? options.currentInvestmentInfo : null;            
        }

        public doInitAsync() {
            var self = this;

            if (this._currentInvestment && !this._currentInvestmentInfo) {
                this._portalServices.reportDataLoader().loadDataSetAsync("/Solovis/Metadata/ModelEnvironment",
                    {
                        investmentOptions: {
                            investmentIdsToLoad: [this._currentInvestment.investmentId]
                        }
                    },
                    function (response, success) {
                        if (success) {
                            if (response.result.dataSet.modelEnvironment.investments.length) {
                                self._currentInvestmentInfo = response.result.dataSet.modelEnvironment.investments[0];
                            }
                            self.notifyInitComplete();
                        }
                        else {
                            self._initErrorText = response.error.message;
                            self.notifyInitComplete();
                        }
                    });
            }
            else {
                this.notifyInitComplete();
            }
        }

        public getCurrentInvestmentInfo() {
            return this._currentInvestmentInfo;
        }

        public doRender() {
            var self = this;

            // #region Owner Entity Form
            this._formDiv = $("<div>")
                .appendTo(this.container);

            this._formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: this._formDiv,
                labelColumnWidth: 90,
                width: 400,
                portalServices: this._portalServices
            });

            let initialOwnerOrHolding = null;
            if (self._currentInvestmentInfo) {                
                initialOwnerOrHolding = {
                    entityId: self._type === "owner" ? self._currentInvestmentInfo.ownerId : self._currentInvestmentInfo.holdingId
                };               
            }

            this._formBuilder.addEntry({
                name: "ownerOrHoldingEntity",
                label: self._type === "owner" ? "Owner" : "Holding",

                initialValue: initialOwnerOrHolding,

                editor: {
                    type: "parameter",
                    parameterOptions: {
                        parameterType: "entity"
                    }
                }                
            });

            $(this._formBuilder).bind("valueChanged", function () {
                self._formValueChangedHandler();
            });
            this._formBuilder.setupDone();

            // #endregion

            this._renderStringFilterListControl();

            if (this._availableHeight) {
                this.setAvailableHeight(this._availableHeight);
                this._availableHeight = null;
            }

            // Trigger initial check for owner or holding investments.
            this._formValueChangedHandler();
        }

        public setAvailableHeight(overallHeight: number) {
            var entityEntryHeight = this._formDiv.outerHeight();

            // Account for kendo using box-sizing: content-box in the tabstrip
            var tabContentBordersHeight = 4;
            var tabContentVerticalPadding = 8;

            var extraSpacing = 5;

            var stringFilterAvailableHeight = overallHeight - entityEntryHeight - tabContentBordersHeight - tabContentVerticalPadding - extraSpacing;

            this._investmentsStringFilterListControl.setAvailableHeight(stringFilterAvailableHeight);
        }

        public _renderStringFilterListControl() {
            var self = this;

            var stringFilterListControlHostDiv = $("<div>")
                .appendTo(this.container);

            this._investmentsStringFilterListControl = new Solovis.UI.StringFilterListControl({
                controlHost: stringFilterListControlHostDiv,
                listItems: [],
                useDefaultSort: true,
                selectedItem: self._currentInvestment
            });

            this._investmentsStringFilterListControl.setAsCurrentControl();

            $(this._investmentsStringFilterListControl)
                .on("selectionChanged", function (e, data) {

                    var investment = {
                        investmentId: data.item.id,
                        label: data.item.label,
                        resourceId: data.item.resourceId
                    };

                    if (self._selectionCallback) {
                        self._selectionCallback(investment);
                    }
                });
        }

        public _formValueChangedHandler() {
            var self = this;

            var ownerEntity = this._formBuilder.getValueByName("ownerOrHoldingEntity");
            var listItems = [];
            if (ownerEntity) {
                this._portalServices.reportDataLoader().loadDataSetAsync("/Solovis/Metadata/EntityInfo",
                    { entityId: ownerEntity.entityId },
                    function (response, success) {
                        if (success) {
                            if (self._type === "owner") {
                                if (response.result.dataSet.entity.owns.length) {
                                    $(response.result.dataSet.entity.owns).each(function (index, ownedInvestment: any) {
                                        var investment = {
                                            id: ownedInvestment.investmentId,
                                            label: ownedInvestment.investmentLabel,
                                            resourceId: ownedInvestment.investmentResourceId
                                        }

                                        listItems.push(investment);
                                    });
                                }
                            }
                            else if (self._type === "holding") {
                                if (response.result.dataSet.entity.ownedBy.length) {

                                    $(response.result.dataSet.entity.ownedBy).each(function (index, ownedByInvestment: any) {
                                        var investment = {
                                            id: ownedByInvestment.investmentId,
                                            label: ownedByInvestment.investmentLabel,
                                            resourceId: ownedByInvestment.investmentResourceId
                                        }

                                        listItems.push(investment);
                                    });
                                }
                            }

                            self._investmentsStringFilterListControl.setListItems(listItems);
                        }
                    });
            }
            else {
                this._investmentsStringFilterListControl.setListItems(listItems);
            }
        }


        public doDestroy() {
        }
    }
}
